(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"] && !Shopify.designMode) return;
  try {
    
  function init() {
    document.querySelectorAll('[data-announce]').forEach(function (el) {
      if (el.__annInit) return;
      el.__annInit = true;
      if (el.dataset.style !== 'rotate') return;
      var items = el.querySelectorAll('.announce__item');
      if (items.length < 2) return;
      /* THE HANDOFF MUST BE SEQUENTIAL, NOT A CROSSFADE.
         This used to remove .is-on from the outgoing message and add it to the
         incoming one in the same tick. Both then ran their .4s opacity
         transition at once, and because the items are absolutely stacked at
         inset:0, halfway through every handoff TWO different sentences were
         painted on top of each other at ~50% opacity. That is the "all messages
         stacked on top of each other" defect — it was never a hidden-state
         problem, it was the crossfade.

         So: fade the current message out, wait for that transition to actually
         finish, and only then fade the next one in. One message is legible at
         any moment, always. */
      var ANN_FADE = 400;
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var i = 0, speed = (parseFloat(el.dataset.speed) || 4) * 1000;
      /* A dwell shorter than the two fades would start the next handoff before
         this one finished, re-creating the overlap at a different speed. */
      speed = Math.max(speed, ANN_FADE * 2 + 600);
      var swapping = false;
      items.forEach(function (m, ix) { m.classList.toggle('is-on', ix === 0); });
      setInterval(function () {
        if (swapping) return;
        swapping = true;
        var next = (i + 1) % items.length;
        items[i].classList.remove('is-on');
        setTimeout(function () {
          i = next;
          items[i].classList.add('is-on');
          swapping = false;
        }, reduce ? 0 : ANN_FADE);
      }, speed);
    });
  }

  init();

  /* THE THEME EDITOR RE-RENDERS A SECTION'S MARKUP WITHOUT RE-RUNNING ITS SCRIPT.
     After any edit, the fresh DOM arrives with no .is-on on any message, so the
     rotator sat dead and every message painted at once — in the editor preview
     only, which is exactly where the owner does her work and forms her judgement
     about whether the theme is broken. Re-initialising on section:load fixes the
     preview and costs nothing on the storefront, where the event never fires. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-announce]')) init();
  });

  } catch(e) { console.error(e); }
})();
})();
